export const validatePwd = (rule, value, callback) => {
  // 检验密码强度
  if (/\d/.test(value) && /[a-z]/.test(value) && /[A-Z]/.test(value)) return callback();
  callback( new Error(rule.message));
};
